import type { CookieSearch } from "./types";

export const isParamValid = (value: CookieSearch): value is string => {
  return !!value && value !== "unknown" && value !== "undefined";
};

export const validateAnalyticsParam = (search: CookieSearch, cookie: CookieSearch) => {
  if (isParamValid(search)) return search;
  if (isParamValid(cookie)) return cookie;
};
